import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { io } from 'socket.io-client';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class SocketService {
  socket: any;
  constructor() {
    //
  }
  initSocket(): void {
    const storageKey = localStorage.getItem(`${environment.storageKey}`);
    if (storageKey && storageKey !== undefined && environment.socketUrl) {
      this.socket = io(environment.socketUrl, {
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 3000,
        reconnectionAttempts: Infinity,
        query: {
          token: storageKey
        }
      });
    }
  }
  emitAction(action: any, payload: any): void {
    this.socket.emit(action, payload);
  }
  public onEvent(event: any): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on(event, (data: any) => observer.next(data));
    });
  }
  disconnect(): void {
    this.socket.disconnect();
  }
}
